import React from 'react'
import ImageDescription from 'components/Slides/ImageDescription'
import PostSvg from '../images/content-php-coolmat.svg'
import Text from 'components/Text'

export default ImageDescription({
  heading: 'How will our post look?',
  image: () => <div>
    <PostSvg />
  </div>,

  description: () => (
    <div>
      <p>WordPress was designed as a blogging platform, so usually the default structure will be very blog-like with a title, date, author and some actual content.</p>
      <p>Using that same structure we can take some bits out we don’t need and then move things around to fit our design.</p>
    </div>
  ),
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/09-our-post.js